import {useStores} from "../stores/useStores";

export const useGetDevice = () => {
    const {interfaceStore} = useStores();

    let isIOS, isAndroidChrome;
    if (interfaceStore.ExecutionEnvironment.canUseDOM) {
        const isTouchDevice = 'ontouchend' in document;
        if ((/iPad|iPhone|iPod/g.test(navigator.userAgent) ||
            (/Macintosh/.test(navigator.userAgent) && isTouchDevice)) && !window.MSStream) {
            isIOS = true;
            isAndroidChrome = false;
        } else if (/Android.*Chrome/g.test(navigator.userAgent) && !window.MSStream) {
            isIOS = false;
            isAndroidChrome = true;
        } else {
            isIOS = false;
            isAndroidChrome = false;
        }
    }

    return {isIOS, isAndroidChrome};
}
